import { AfterViewInit, Component, DestroyRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute } from '@angular/router';
import { TableLazyLoadEvent } from 'primeng/table';
import { dbStringToGui } from 'src/app/shared/helpers/mappers/mapping-utils';
import { TableDataService } from 'src/app/shared/services/table-data.service';
import { TableConfig } from '../../shared/components/app-table/app-table-models';
import { Inskicksresultat } from './inskicks-resultat.models';
import { InskicksResultatService } from './inskicks-resultat.service';

@Component({
    selector: 'lib-inskicks-resultat',
    templateUrl: './inskicks-resultat.component.html',
    styleUrls: ['./inskicks-resultat.component.css'],
    standalone: false
})
export class InskicksResultatComponent implements AfterViewInit {
  tableConfig = this.getTableConfig();
  rows: any = [];
  expanded = {};
  paginationLength = 0;

  private irService = inject(InskicksResultatService);
  private destroyRef = inject(DestroyRef);
  private tableDataService = inject(TableDataService);
  protected loading = true;
  protected originalData!: any;

  ngAfterViewInit(): void {
    this.irService
      .getResultat()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((res) => {
        const data: Inskicksresultat[] = Object.values(res);
        this.originalData = data;

        this.sort({
          first: 0,
          filters: {},
          multiSortMeta: this.getTableConfig().multiSortMeta,
        });
        this.loading = false;

        //timeout needed for primeng table to expand row. multiple bug reports but primeng team do not seem to have adressed this...
        setTimeout(() => {
          this.expandProv();
        }, 10);
      });
  }

  lazyExpand(e: any) {
    this.tableConfig.rows = this.originalData.slice(e.first, e.first + 15);
  }

  sort(e: TableLazyLoadEvent) {
    if (!this.originalData) return;
    this.tableConfig.rows = this.tableDataService.filterSort(e, this.originalData).result;
    this.paginationLength = this.tableDataService.filterSort(e, this.originalData).paginationLength;
  }

  private getTableConfig(): TableConfig {
    return {
      dataKey: 'prov_labb_provtagningsar',
      accordionContent: 'inskicksresultat',
      multiSortMeta: [
        { field: 'provtagnings_datum', order: 1 },
        { field: 'labb_kod', order: 1 },
        { field: 'prov_id', order: 1 },
      ],
      columns: [
        { field: 'toggler', header: '', isRowToggler: true },
        { field: 'labb_kod', header: 'Laboratorium', sortByField: 'labb_kod', columnFilter: 'multi-select' },
        { field: 'prov_id', header: 'Prov ID', sortByField: 'prov_id', columnFilter: 'text' },
        { field: 'analys_namn', header: 'Analys', sortByField: 'analys_namn', columnFilter: 'text' },
        { field: 'provmaterial_namn', header: 'Provmaterial', sortByField: 'provmaterial_namn', columnFilter: 'text' },
        { field: 'smittamne_namn', header: 'Smittämne', sortByField: 'smittamne_namn', columnFilter: 'text' },
        {
          field: 'patient_fodelse',
          header: 'Födelsedatum',
          sortByField: 'patient_fodelse',
          columnFilter: 'text',
          mapView: (date: string) => date ?? 'Okänt',
        },
        {
          field: 'patient_kon',
          header: 'Kön',
          sortByField: 'patient_kon',
          columnFilter: 'text',
          mapView: (gender) => dbStringToGui(gender),
        },
        {
          field: 'provtagnings_datum',
          header: 'Provtagningsdatum',
          type: 'date',
          sortByField: 'provtagnings_datum',
          columnFilter: 'text',
        },
      ],
    };
  }

  private expandProv() {
    const provLabbProvtagningsar = (window as any).provLabbProvtagningsar;
    if (provLabbProvtagningsar) {
      const provData = this.originalData.find((row: any) => row.prov_labb_provtagningsar.trim() === provLabbProvtagningsar);
      const index = this.originalData.indexOf(provData);
      this.tableConfig.rows = this.originalData.slice(index, index + 15);
      this.expanded = { id: provData.prov_labb_provtagningsar };
    }
  }
}
